import i18n from 'i18next';

export type Lang = 'ru' | 'kk';

export function getLang() {
  return i18n.language;
}
